<template>
  <div id="app_content" class="reserved" v-if="isMounted">
    <div class="container-articles">
      <div class="product-jumbo">

        <image-elm
            :elm="prodotti[0]"
        />
        <div class="product-title">
          <p class="categoria">


            <strong>
              <cod-elm :elm=prodotti[0]></cod-elm>
            </strong>

          </p>
          <!--          <p class="prod-des-art">{{prodotti[0].des_art}}</p>-->
          <p class="microfamiglia" v-if="prodotti[0].microfamily !== null">
            {{ prodotti[0].microfamily.descrizione }}
          </p>
          <p class="descrizione">
            {{ prodotti[0].family.descrizione }}
          </p>
          <p class="descrizione">
            {{ prodotti[0].category.descrizione }}
          </p>
          <p class="colore" v-if="prodotti[0].color !== null">
            {{ prodotti[0].color.descrizione }}
          </p>
        </div>
      </div>
      <hr/>

      <datasheetGeneral :datasheet="prodotti[0].datasheet" :prodotti="prodotti" />

      <h2>{{ trans.get("b2b.article.select-product") }}</h2>
      <div class="selezione-prodotto">

          <datasheet-heading :datasheet="prodotti[0].datasheet" @labels="totLabels" />

        <div class="prodotti" v-for="(singleArt, key) in prodotti" v-if="isMounted" >
          <single_art_card
              v-if="currentUser"
              class="single-art-card"
              :cod_art="singleArt.cod_art"
              :des_art="singleArt.des_art"
              :datasheet="singleArt.datasheet"
              :qtaimballo="singleArt.qta_per_imballo > 0 ? singleArt.qta_per_imballo : 1"
              :currentUser="currentUser"
              :currentRole="currentRole"
              :unita_misura="singleArt.unita_misura"
              :chiave="key"
              :total-labels="totalLabels"
              @loaded="watchLoaded"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import etichetta from "./etichetta";
import single_art_card from "./single-art-card";
import datasheetGeneral from "./datasheet-general";
import datasheetHeading from "./datasheet-heading";

export default {
  name: "prodotti",
  components: {
    etichetta,
    single_art_card,
    datasheetGeneral,
    datasheetHeading
  },
  data: function () {
    return {
      isMounted: false,
      isloaded: false,
      prodotti: null,
      currentEtichetta: null,
      // currentUser: this.currentUser(),
      // currentRole: this.currentRole(),
      isLoading: false,
      totalLabels: null,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.nav.user.cod_cli_for
    },
    currentRole() {
      return this.$store.state.nav.user.id_ruolo
    }
  },
  mounted() {
    this.getArticles();

   //this.getCurrentUser();
  },
  methods: {
    totLabels(values){
      this.totalLabels = values
    },
    watchLoaded: function (index) {
      if (index === this.prodotti.length - 1) {
        this.isLoading = false;
      }
    },
    getCurrentUser: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-current-user",
      })
          .then((res) => {
            //console.log(res.data)
            this.currentUser = res.data.user;
            this.currentRole = res.data.role;
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    getArticles: function () {
      this.isLoading = true;
      let pathname = window.location.pathname.split("/");
      let last = pathname[pathname.length -1]
      if  (last === 'SC'){
        let color = 'SC'
      } else {
        last = last.replace('%20', ' ')
        axios({
          method: "get",
          url: window.location.origin + "/data/get-family",
          params: {
            cod_card: last,
            type: "articles",
          },
        })
            .then((res) => {
              this.prodotti = res.data.family;
              //console.log(this.prodotti)
              this.isMounted = true;
            })
            .catch((err) => {
              this.$store.commit("add_message", {
                type: "error",
                message: err.response.data.message,
              });
            });
      }


    },
  },
};
</script>

<style lang="scss" scoped>
.reserved {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 50px;

  .container-articles {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    padding: 0 10px;

    h2 {
      font-size: 21px;
      margin-top: 100px;
      margin-bottom: 30px;
    }

    .product-jumbo {
      background-color: #f5f5f5;
      display: flex;
      justify-content: center;
      position: relative;

      img {
        width: 460px;
        height: 330px;
      }

      .product-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50%;
        margin-left: auto;
        position: absolute;
        right: 0;
        @media (max-width: 576px){
          width: 100%;
          bottom: 0;
        }
        .prod-des-art {
          font-size: 20px;
        }

        .descrizione,
        .colore {
          text-transform: lowercase;

          &:first-letter {
            text-transform: uppercase;
          }

        }

        .categoria {
          font-size: 32px;
        }

        .descrizione {
          font-size: 16px;
        }
      }
    }

    hr {
      background-color: #979797;
    }

    .product-details {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .titolo {
        font-size: 19px;
        width: 50%; //width: auto;
        flex-direction: row; //flex-direction: column;
        .profilo {
          height: 110px;

          img {
            margin-left: -15px;
            width: 70%;
          }
        }
      }

      .specifiche,
      .c-frizione {
        .titolo {
          font-size: 19px;
          margin-bottom: 36px;
        }

        .lista-spec {
          font-size: 15px;

          li {
            display: flex;

            .contenuto {
              margin-left: auto;
            }

            .contenuto-colore {
              margin-left: auto;
              text-transform: lowercase;

              &:first-letter {
                text-transform: uppercase;
              }
            }
          }
        }
      }

      .specifiche {
        width: 100%;
      }

      .c-frizione {
        width: 50%;
      }
    }

    .selezione-prodotto {
      position: relative;

      .heading {
        display: none;
        font-size: 14px;
        margin-top: 50px;
        margin-bottom: 40px;
        //padding-left: 50px;
        flex-direction: column;

        span {
          display: inline-block;
          width: calc(100% / 7);
          text-align: center;
          text-transform: capitalize;

          &.diametro,
          &.peso {
            width: calc(100% / 12);
          }
        }
      }

      .prodotti {
        .single-article-card {
          margin-bottom: 15px;
        }
      }
    }
  }
}

@media (min-width: 576px) {
  .reserved {
    .container-articles {
      .product-jumbo {
        position: initial;

        .product-title {
          position: initial;
        }
      }

      .product-details {
        flex-wrap: nowrap;

        .titolo {
          width: auto;
          flex-direction: column;
        }

        .specifiche {
          width: calc(100% / 3);
        }

        .c-frizione {
          width: calc(100% / 4);
        }
      }
    }
  }
  .reserved .container-articles .selezione-prodotto .heading {
    display: flex;
    flex-direction: row;
  }

}

@media (min-width: 1200px) {
  .reserved {
    .container-articles {
      width: 1200px;
      padding: 0;
    }
  }
}
</style>
